import { EDIT_STRUCTURE_ITEM } from "../../../../enums/Request/leader.requests.types";

export const editStructureAction = () => {
    return {
        type: EDIT_STRUCTURE_ITEM,
    };
};
